export const SET_CHARGE = 'setCharge'
export const SET_CHARGES = 'setCharges'
export const SET_CHARGES_SIMPLE = 'setChargesSimple'
export const SET_CATEGORIES = 'setCategories'
export const SET_CHARGE_ACTIVE = 'setChargeActive'
export const CHARGE_RESET = 'setReset'
export const CHARGE_RESET_STATE = 'setResetState'
export const SET_CHARGE_PAGINATION = 'setChargePagination'